import { NetworkId } from '@/types/network'
import { match } from 'ts-pattern'
import { Hex } from 'viem'

export function getStaking2aAddress(chainId: NetworkId) {
	const address = match(chainId)
		// Spicy
		.with(88882, () => '0x1e863BF2e580eC31D384D1810b44886602e50BB7')
		// Staging
		.with(88883, () => '0x9fCF0036D2B9A6B1B6Ca2DD545DeD71AcFdFD2D8')
		// Mainnet
		.with(88888, () => '0x5cA4C88339D89B2547a001003Cca84F62F557A72') // dummy one is 0xEf4023b9444A14BA2C468E27CfE227e9C7A261D1
		.exhaustive()

	return address as Hex
}
